import { Utterance } from "@knowt/syncing/types/common";

export const formatTimestamp = (timestamp: number) => {
    const minutes = Math.floor(timestamp / 60);
    const seconds = Math.floor(timestamp % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const areUtterancesEqual = (left: Utterance[number], right: Utterance[number]) => {
    return JSON.stringify(left) === JSON.stringify(right);
};
